.wrapper {
  outline: none;
  border: none;
}

.dropLine {
  height: 4px;
  border-radius: 2px;
  margin-top: 4px;
  margin-bottom: 4px;
  pointer-events: none;
  background: var(--tuna-palette-primary-main);
  box-shadow: 0 0 8px color-mix(in srgb, var(--tuna-palette-primary-main) 40%, transparent);
  animation: dropLinePulse 1.2s ease-in-out infinite;
}

@keyframes dropLinePulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

.block {
  position: relative;
  align-items: center;
  vertical-align: bottom;
  isolation: isolate;
}

/* Extend the block's hover region 16px to the left to bridge the dead zone
 * between the block and its gutter handle. Without this, moving the cursor
 * from block content toward the handle crosses an empty 16px strip where
 * the block loses :hover and the handle fades to opacity: 0 mid-reach. */
.block::before {
  content: '';
  position: absolute;
  top: 0;
  left: -16px;
  width: 16px;
  height: 100%;
}

.block ::selection {
  background-color: var(--tuna-palette-primary-light);
  color: var(--tuna-palette-primary-contrastText);
}

.block--inline {
  display: inline-flex;
}

.block--border {
  border-style: solid;
  border-color: var(--tuna-palette-action-disabled);
  border-radius: var(--tuna-shape-borderRadius, 4px);
  border-width: 0.8px;
}

.block--focused {
  transition: border-color 0.3s;
  border-color: var(--tuna-palette-primary-main);
  border-right-width: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.block--dragOver {
  background: color-mix(in srgb, var(--tuna-palette-primary-main) 4%, transparent);
  border-radius: var(--tuna-shape-borderRadius, 4px);
}

.block--focusRight {
  transition: border-color 0.3s;
  border-top-style: none;
  border-bottom-style: none;
  border-left-style: none;
  border-right-style: solid;
  border-top-width: 0;
  border-bottom-width: 0;
  border-left-width: 0;
  border-right-width: 4px;
  border-right-color: var(--tuna-palette-primary-main);
  border-radius: 0;
}
